import { useTranslation } from 'react-i18next';
import useCalculatorState from 'hooks/useCalculatorState';

import Range from '@molecules/Range';
import Input from '@molecules/Input';
import useLayoutConfigState from 'hooks/useLayoutConfigState';

import styles from './styles';

export interface OverlapRangeProps {
  direction: 'horizontal' | 'vertical',
  label?: string,
}

const OverlapRange = ({ direction, label } : OverlapRangeProps) => {
  const { t } = useTranslation();

  const {
    horizontalOverlapError,
    verticalOverlapError,
    setHorizontalOverlapValue,
    setVerticalOverlapValue,
    horizontalOverlap,
    verticalOverlap,
  } = useLayoutConfigState();

  const {
    dimensions,
  } = useCalculatorState();

  const {
    type: unitType,
  } = dimensions;

  return (
    <div className={styles.container}>
      <Input
        id={`${direction}OverlapInput`}
        label={t(`${label}`)}
        placeholder={unitType}
        onChange={(val) => {
          const fixedValue = Math.trunc(Number(val));
          if (direction === 'vertical') setVerticalOverlapValue(fixedValue);
          if (direction === 'horizontal') setHorizontalOverlapValue(fixedValue);
        }}
        value={direction === 'horizontal' ? String(horizontalOverlap) : String(verticalOverlap)}
        error={direction === 'horizontal' ? horizontalOverlapError : verticalOverlapError}
        className={styles.input}
        min={0}
        max={unitType === 'MM' ? 200 : 8}
      />
      <Range
        id={`${direction}OverlapRange`}
        value={direction === 'horizontal' ? horizontalOverlap : verticalOverlap}
        onChange={(val) => {
          if (direction === 'vertical') setVerticalOverlapValue(val);
          if (direction === 'horizontal') setHorizontalOverlapValue(val);
        }}
        className={styles.range}
      />
    </div>
  );
};

export default OverlapRange;
